export enum cookieNames {
  INTEGRATION_TOKEN = 'shopIntegrationToken',
  INTEGRATION_HASDATA = 'shopIntegrationHasData',
  REFERRAL_TYPE = 'referralType',
  REFERRER_PHONE = 'bcContactNumber',
  SALESFORCE_ID = 'salesforceId',
  REFERRER = 'referrer',
}
